import { render, staticRenderFns } from "./MovingAccountsModal.vue?vue&type=template&id=104304bc"
import script from "./MovingAccountsModal.vue?vue&type=script&lang=js"
export * from "./MovingAccountsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports